import apiClient from '@/store/helpers/vyte-event-client';

const SET_FORM_LOADING = 'SET_FORM_LOADING';
const SET_GET_USER_LOADING = 'SET_GET_USER_LOADING';
const SET_USER = 'SET_USER';

const state = {
  formLoading: false,
  userLoading: false,
  user: null,
  serverError: null,
};

const mutations = {
  // eslint-disable-next-line
  [SET_FORM_LOADING](state, loading) {
    // eslint-disable-line
    state.formLoading = loading;
  },
  // eslint-disable-next-line
  [SET_GET_USER_LOADING](state, loading) {
    // eslint-disable-line
    state.userLoading = loading;
  },
  // eslint-disable-next-line
  [SET_USER](state, data) {
    // eslint-disable-line
    state.user = data;
  },
};

const actions = {
  async submitForm({ commit }, { eventId, userId, email }) {
    commit(SET_FORM_LOADING, true);

    const response = {
      ok: true,
      message: '',
    };

    try {
      const data = await apiClient.post('/email', { eventId, userId, email });
      commit(SET_FORM_LOADING, false);
      if (data.data.redirectUrl) {
        window.location.replace(data.data.redirectUrl);
        return response;
      }

      return response;
    } catch (error) {
      response.ok = false;
      if (error.response) {
        response.message = error.response.data.error;
      } else {
        response.message = error.message;
      }
    }

    commit(SET_FORM_LOADING, false);
    return response;
  },
  async getUser({ commit }, { eventId, token }) {
    commit(SET_GET_USER_LOADING, true);

    try {
      const response = await apiClient.post('/user', { eventId, token });
      if (response.data.redirectUrl) {
        window.location.replace(response.data.redirectUrl);
        return;
      }
      commit(SET_USER, response.data);
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error setting form value:', error);
    }

    commit(SET_GET_USER_LOADING, false);
  },
};

export default {
  state,
  mutations,
  actions,
};
